import { AgentAvailabilityState } from '@bd/agent/types'

export const state: AgentAvailabilityState = {
  availabilityRules: [],
  availabilityException: {
    isLoading: false,
    content: undefined,
  },
}
